import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconKeyboard = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M6 12.5C6.55229 12.5 7 12.0523 7 11.5C7 10.9477 6.55229 10.5 6 10.5C5.44771 10.5 5 10.9477 5 11.5C5 12.0523 5.44771 12.5 6 12.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.75 17.75C7.75 17.3358 8.08579 17 8.5 17H15.5C15.9142 17 16.25 17.3358 16.25 17.75C16.25 18.1642 15.9142 18.5 15.5 18.5H8.5C8.08579 18.5 7.75 18.1642 7.75 17.75Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 11.5C10 12.0523 9.55229 12.5 9 12.5C8.44771 12.5 8 12.0523 8 11.5C8 10.9477 8.44771 10.5 9 10.5C9.55229 10.5 10 10.9477 10 11.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13 11.5C13 12.0523 12.5523 12.5 12 12.5C11.4477 12.5 11 12.0523 11 11.5C11 10.9477 11.4477 10.5 12 10.5C12.5523 10.5 13 10.9477 13 11.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 11.5C16 12.0523 15.5523 12.5 15 12.5C14.4477 12.5 14 12.0523 14 11.5C14 10.9477 14.4477 10.5 15 10.5C15.5523 10.5 16 10.9477 16 11.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19 11.5C19 12.0523 18.5523 12.5 18 12.5C17.4477 12.5 17 12.0523 17 11.5C17 10.9477 17.4477 10.5 18 10.5C18.5523 10.5 19 10.9477 19 11.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 15.5C6.55229 15.5 7 15.0523 7 14.5C7 13.9477 6.55229 13.5 6 13.5C5.44771 13.5 5 13.9477 5 14.5C5 15.0523 5.44771 15.5 6 15.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 14.5C10 15.0523 9.55229 15.5 9 15.5C8.44771 15.5 8 15.0523 8 14.5C8 13.9477 8.44771 13.5 9 13.5C9.55229 13.5 10 13.9477 10 14.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13 14.5C13 15.0523 12.5523 15.5 12 15.5C11.4477 15.5 11 15.0523 11 14.5C11 13.9477 11.4477 13.5 12 13.5C12.5523 13.5 13 13.9477 13 14.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 14.5C16 15.0523 15.5523 15.5 15 15.5C14.4477 15.5 14 15.0523 14 14.5C14 13.9477 14.4477 13.5 15 13.5C15.5523 13.5 16 13.9477 16 14.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19 14.5C19 15.0523 18.5523 15.5 18 15.5C17.4477 15.5 17 15.0523 17 14.5C17 13.9477 17.4477 13.5 18 13.5C18.5523 13.5 19 13.9477 19 14.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M21.75 2C21.75 1.58579 21.4142 1.25 21 1.25C20.5858 1.25 20.25 1.58579 20.25 2V2.82353C20.25 3.51389 19.6904 4.07353 19 4.07353H14C12.4812 4.07353 11.25 5.30475 11.25 6.82353V7.5H5.5C3.42893 7.5 1.75 9.17893 1.75 11.25V17.75C1.75 19.8211 3.42893 21.5 5.5 21.5H18.5C20.5711 21.5 22.25 19.8211 22.25 17.75V11.25C22.25 9.17893 20.5711 7.5 18.5 7.5H12.75V6.82353C12.75 6.13317 13.3096 5.57353 14 5.57353H19C20.5188 5.57353 21.75 4.34231 21.75 2.82353V2ZM3.25 11.25C3.25 10.0074 4.25736 9 5.5 9H18.5C19.7426 9 20.75 10.0074 20.75 11.25V17.75C20.75 18.9926 19.7426 20 18.5 20H5.5C4.25736 20 3.25 18.9926 3.25 17.75V11.25Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconKeyboard as ReactComponent };
